// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-calendar-weekly {
  background-color: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
  border-top: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
  border-left: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
}
:where(.vuetify-styles) .v-calendar-weekly .v-calendar-weekly__head-weekday {
  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
}
:where(.vuetify-styles) .v-calendar-weekly .v-calendar-weekly__head-weekday.v-past {
  color: rgb(var(--v-theme-on-surface));
}
:where(.vuetify-styles) .v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside {
  background-color: rgb(var(--v-theme-surface-light));
  color: rgb(var(--v-theme-on-surface-light));
}
:where(.vuetify-styles) .v-calendar-weekly .v-calendar-weekly__head-weeknumber {
  background-color: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
}
:where(.vuetify-styles) .v-calendar-weekly .v-calendar-weekly__day {
  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
  border-bottom: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
}
:where(.vuetify-styles) .v-calendar-weekly .v-calendar-weekly__day.v-outside {
  background-color: rgb(var(--v-theme-surface-light));
  color: rgb(var(--v-theme-on-surface-light));
}
:where(.vuetify-styles) .v-calendar-weekly .v-calendar-weekly__weeknumber {
  background-color: rgb(var(--v-theme-surface));
  color: rgb(var(--v-theme-on-surface));
  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
  border-bottom: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;
}

:where(.vuetify-styles) .v-calendar-weekly {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

:where(.vuetify-styles) .v-calendar-weekly__head {
  display: flex;
  -webkit-user-select: none;
          user-select: none;
}

:where(.vuetify-styles) .v-calendar-weekly__head-weekday {
  flex: 1 0 20px;
  -webkit-user-select: none;
          user-select: none;
  padding: 0px 4px 0px 4px;
  font-size: 11px;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

:where(.vuetify-styles) .v-calendar-weekly__head-weeknumber {
  position: relative;
  flex: 0 0 24px;
}

:where(.vuetify-styles) .v-calendar-weekly__week {
  display: flex;
  flex: 1;
  height: unset;
  min-height: 0;
}

:where(.vuetify-styles) .v-calendar-weekly__weeknumber {
  display: flex;
  flex: 0 0 24px;
  height: unset;
  min-height: 0;
  padding-top: 14.5px;
  text-align: center;
}
:where(.vuetify-styles) .v-calendar-weekly__weeknumber > small {
  width: 100% !important;
}

:where(.vuetify-styles) .v-calendar-weekly__day {
  flex: 1;
  width: 0;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  padding: 0px 0px 0px 0px;
  min-width: 0;
}
:where(.vuetify-styles) .v-calendar-weekly__day.v-present .v-calendar-weekly__day-month {
  color: currentColor;
}

:where(.vuetify-styles) .v-calendar-weekly__day-label {
  text-decoration: none;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  box-shadow: none;
  text-align: center;
  margin: 4px 0 0 0;
}
:where(.vuetify-styles) .v-calendar-weekly__day-label .v-icon-btn {
  font-size: 12px;
}

:where(.vuetify-styles) .v-calendar-weekly__day-month {
  position: absolute;
  text-decoration: none;
  -webkit-user-select: none;
          user-select: none;
  box-shadow: none;
  top: 0;
  left: 36px;
  height: 32px;
  line-height: 32px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VCalendar/VCalendarWeekly.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,qCAAqC;EACrC,0EAA0E;EAC1E,2EAA2E;AAC7E;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mDAAmD;EACnD,2CAA2C;AAC7C;AACA;EACE,6CAA6C;EAC7C,qCAAqC;EACrC,4EAA4E;AAC9E;AACA;EACE,4EAA4E;EAC5E,6EAA6E;AAC/E;AACA;EACE,mDAAmD;EACnD,2CAA2C;AAC7C;AACA;EACE,6CAA6C;EAC7C,qCAAqC;EACrC,4EAA4E;EAC5E,6EAA6E;AAC/E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".v-calendar-weekly {\n  background-color: rgb(var(--v-theme-surface));\n  color: rgb(var(--v-theme-on-surface));\n  border-top: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n  border-left: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n}\n.v-calendar-weekly .v-calendar-weekly__head-weekday {\n  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n}\n.v-calendar-weekly .v-calendar-weekly__head-weekday.v-past {\n  color: rgb(var(--v-theme-on-surface));\n}\n.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside {\n  background-color: rgb(var(--v-theme-surface-light));\n  color: rgb(var(--v-theme-on-surface-light));\n}\n.v-calendar-weekly .v-calendar-weekly__head-weeknumber {\n  background-color: rgb(var(--v-theme-surface));\n  color: rgb(var(--v-theme-on-surface));\n  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n}\n.v-calendar-weekly .v-calendar-weekly__day {\n  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n  border-bottom: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n}\n.v-calendar-weekly .v-calendar-weekly__day.v-outside {\n  background-color: rgb(var(--v-theme-surface-light));\n  color: rgb(var(--v-theme-on-surface-light));\n}\n.v-calendar-weekly .v-calendar-weekly__weeknumber {\n  background-color: rgb(var(--v-theme-surface));\n  color: rgb(var(--v-theme-on-surface));\n  border-right: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n  border-bottom: rgba(var(--v-border-color), var(--v-border-opacity)) 1px solid;\n}\n\n.v-calendar-weekly {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.v-calendar-weekly__head {\n  display: flex;\n  user-select: none;\n}\n\n.v-calendar-weekly__head-weekday {\n  flex: 1 0 20px;\n  user-select: none;\n  padding: 0px 4px 0px 4px;\n  font-size: 11px;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.v-calendar-weekly__head-weeknumber {\n  position: relative;\n  flex: 0 0 24px;\n}\n\n.v-calendar-weekly__week {\n  display: flex;\n  flex: 1;\n  height: unset;\n  min-height: 0;\n}\n\n.v-calendar-weekly__weeknumber {\n  display: flex;\n  flex: 0 0 24px;\n  height: unset;\n  min-height: 0;\n  padding-top: 14.5px;\n  text-align: center;\n}\n.v-calendar-weekly__weeknumber > small {\n  width: 100% !important;\n}\n\n.v-calendar-weekly__day {\n  flex: 1;\n  width: 0;\n  overflow: hidden;\n  user-select: none;\n  position: relative;\n  padding: 0px 0px 0px 0px;\n  min-width: 0;\n}\n.v-calendar-weekly__day.v-present .v-calendar-weekly__day-month {\n  color: currentColor;\n}\n\n.v-calendar-weekly__day-label {\n  text-decoration: none;\n  user-select: none;\n  cursor: pointer;\n  box-shadow: none;\n  text-align: center;\n  margin: 4px 0 0 0;\n}\n.v-calendar-weekly__day-label .v-icon-btn {\n  font-size: 12px;\n}\n\n.v-calendar-weekly__day-month {\n  position: absolute;\n  text-decoration: none;\n  user-select: none;\n  box-shadow: none;\n  top: 0;\n  left: 36px;\n  height: 32px;\n  line-height: 32px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
